import React, {useEffect, useMemo} from 'react'
import _ from 'lodash/fp'
import styled from 'styled-components/macro';
import {useIntl} from "react-intl";
import {Errors, validation} from "@startlibs/form";
import {StartlibsProvider} from "@startlibs/core";
import {createGlobalStyle} from "styled-components";

styled;
const identityIntl = {
  formatMessage: ({defaultMessage}) => defaultMessage
}
export const makeStartlibsConfig = (intl = identityIntl) => ({
  dialogs: {},
  labels: {
    EditableBox: {
      save: intl.formatMessage({
        defaultMessage:'Save',
        description:'Save button for editable box'
      }),
      saveNew: intl.formatMessage({
        defaultMessage: 'Save',
        description: 'Save button for editable box (new item)'
      }),
      cancel: intl.formatMessage({
        defaultMessage: 'Cancel',
        description: 'Cancel button for editable box'
      })
    }
  },
  confirmDialogLabels: {
    title: 'Your changes will not be saved',
    content: 'The changes made in this screen were not saved. Would you like to quit anyway?',
    confirm: 'Save Changes',
    discard: 'Discard Changes',
    cancel: 'Cancel'
  },
  ErrorDialog: {
    title: 'This content could not be loaded',
    content: <React.Fragment>Please refresh the page and try again. <br/>If the problem persists, contact
      us.</React.Fragment>,
    close: 'Close'
  },
  fetchRoutes: []
})

const ErrorMarginStyle = createGlobalStyle`
  ${Errors.Container} {
    margin-top: 1rem;
  }
`

export const IntlStartlibsProvider = ({children}) => {
  const intl = useIntl()
  const hasIntl = !_.isEmpty(intl.messages)
  const startlibsConfig = useMemo(() => makeStartlibsConfig(hasIntl ? intl : undefined),[hasIntl])
  return <StartlibsProvider value={startlibsConfig}>
    <ErrorMarginStyle/>
    {children}
    <SetAjaxDefaultError />
  </StartlibsProvider>
}

export const SetAjaxDefaultError = () => {
  const outerIntl = useIntl()
  const hasIntl = !_.isEmpty(outerIntl.messages)

  useEffect(() => {
    const intl = hasIntl ? outerIntl : identityIntl
    validation.setErrorMessages({
      SERVER_ERROR:intl.formatMessage({
        defaultMessage:'The communication with the server has failed, please check your connection and try again',
        description:'Default error message for ajax requests'
      }),
      required: intl.formatMessage({defaultMessage: 'This field is required', description: 'Validation message for required fields'}),
      emailValidation: intl.formatMessage({defaultMessage: 'Please enter a valid email address', description: 'Validation message for email fields'}),
      minLength: (n) => intl.formatMessage({
        defaultMessage: 'Please enter at least {n} characters',
        description: 'Validation message for min length'
      }, {n}),
      confirmPassword: intl.formatMessage({
        defaultMessage: 'The passwords do not match',
        description: 'Validation message for password confirmation fields'
      }),
      confirmEmails: intl.formatMessage({
        defaultMessage: 'The email addresses do not match',
        description: 'Validation message for email confirmation fields'
      })
    })
  }, [hasIntl]);
  return null
}